<template>
  <div id="home">
    <div id="top">
      <div id="top-animal">
        <el-carousel height="600px" :interval="5000">
          <el-carousel-item v-for="item in topImagesNotRouter" :key="item.name">
            <a :href="item.src"><div :style="{backgroundImage:'url(' + item.img + ')'}" :title="item.title"></div></a>
          </el-carousel-item>
          <el-carousel-item v-for="item in topImagesRouter" :key="item.name">
            <router-link :to="item.to"><div :style="{backgroundImage:'url(' + item.img + ')'}" :title="item.name"></div></router-link>
          </el-carousel-item>
        </el-carousel>
      </div>
    </div>
    <div id="support">
      <h1 class="supportTitle">产品服务</h1>
      <div class="supportItems">
        <div class="supportItem1">
          <router-link to="/ProductAndService/Phbo">
            <img :src="supportItems[0].img"/>
            <h1 class="itemTitle">{{supportItems[0].title}}</h1>
            <h2 class="itemContent">{{supportItems[0].content}}</h2>
          </router-link>
        </div><!--
     --><div class="supportItem2">
          <router-link to="/ProductAndService/HMOC">
            <img :src="supportItems[1].img"/>
            <h1 class="itemTitle">{{supportItems[1].title}}</h1>
            <h2 class="itemContent">{{supportItems[1].content}}</h2>
          </router-link>
        </div><!--
     --><div class="supportItem3">
          <router-link to="/ProductAndService/DataService">
            <img :src="supportItems[2].img"/>
            <h1 class="itemTitle">{{supportItems[2].title}}</h1>
            <h2 class="itemContent">{{supportItems[2].content}}</h2>
          </router-link>
        </div><!--
     --><div class="supportItem4">
          <router-link style="margin-bottom: 9px" to="/ProductAndService/MOBEC">
            <img :src="supportItems[3].img"/>
            <h1 class="itemTitle">{{supportItems[3].title}}</h1>
            <h2 class="itemContent">{{supportItems[3].content}}</h2>
          </router-link>
        </div>
      </div>
    </div>
    <div id="CopingStyle">
      <h1 class="CopingStyleTitle">解决方案</h1>
      <div class="CopingStyleItems">
        <div class="CopingStyleItem1">
          <router-link to="/Solution/Case">
            <img :src="CopingStyleItems[0].img"/>
            <h1 class="itemTitle">{{CopingStyleItems[0].title}}</h1>
            <h2 class="itemContent">{{CopingStyleItems[0].content}}</h2>
          </router-link>
        </div><!--
     --><div class="CopingStyleItem2">
          <router-link style="margin-bottom: 9px" to="/Solution/CHMAS">
            <img :src="CopingStyleItems[1].img"/>
            <h1 class="itemTitle">{{CopingStyleItems[1].title}}</h1>
            <h2 class="itemContent">{{CopingStyleItems[1].content}}</h2>
          </router-link>
        </div><!--
     --><div class="CopingStyleItem3">
          <router-link to="/Solution/LCStudies">
            <img :src="CopingStyleItems[2].img"/>
            <h1 class="itemTitle">{{CopingStyleItems[2].title}}</h1>
            <h2 class="itemContent">{{CopingStyleItems[2].content}}</h2>
          </router-link>
        </div><!--
     --><div class="CopingStyleItem4">
          <router-link to="/Solution/HugeData">
            <img :src="CopingStyleItems[3].img"/>
            <h1 class="itemTitle">{{CopingStyleItems[3].title}}</h1>
            <h2 class="itemContent">{{CopingStyleItems[3].content}}</h2>
          </router-link>
        </div>
      </div>
    </div>
    <div id="customer">
      <h1 class="customerTitle">我们的客户</h1>
      <div id="customerItems" class="customerItems">
        <ul id="customerUl">
          <li v-for="item in imglists"><img :src="item.src"/></li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'home',
  data(){
    return{
      imglists:[
        {src:require('../assets/images/home/customer1.png')},
        {src:require('../assets/images/home/customer2.png')},
        {src:require('../assets/images/home/customer3.png')},
        {src:require('../assets/images/home/customer4.png')},
        {src:require('../assets/images/home/customer5.png')},
        {src:require('../assets/images/home/customer6.png')},
        {src:require('../assets/images/home/customer7.png')}
      ],
      supportItems:[
        {img:require('../assets/images/home/support1.png'),title:'量表评估系统',content:'一套SAAS（Software-as-a-service）的量表评估系统；可定制复杂的量表；支持多语言；支持SPSS、STATA数据格式。'},
        {img:require('../assets/images/home/support2.png'),title:'儿童健康管理',content:'主要有儿童检测及儿童保健两大方面，包括记录成长发育、跟踪记录孕妇新生儿、育儿保健干预指导等四大功能模块。'},
        {img:require('../assets/images/home/support3.png'),title:'数据服务',content:'基于自主开发的量表评估系统和档案管理系统，针对客户的多样化需求，实现从数据收集、计算分析到可视化的完整服务。'},
        {img:require('../assets/images/home/support4.png'),title:'运动/睡眠身体能耗监测仪',content:'全球科研领域使用最广泛的人体活动检测仪ActiGraph设备、AMI各种睡眠监测仪器'},
      ],
      CopingStyleItems:[
        {img:require('../assets/images/home/CopingStyle1.png'),title:'流行病学调研',content:'由量表评估系统、数据管理系统、质量管控系统组成，包括制定调查实施方案，进行正式调查，整理分析资料，得出报告结论一整套完整流程。'},
        {img:require('../assets/images/home/CopingStyle2.png'),title:'医院儿童健康管理',content:'健康成长全程跟踪，为每一位儿童建立健康档案，潜在问题重点跟踪，进行个性化管理与追踪。线下线上配合评估，实时监测健康情况。'},
        {img:require('../assets/images/home/CopingStyle3.png'),title:'队列人群研究',content:'引入AI图像识别技术，使用为队列研究定制的量表评估系统，节省实施人员的时间，同时保证提供数据的准确性，真实可靠性。'},
        {img:require('../assets/images/home/CopingStyle4.png'),title:'大数据计算分析',content:'提供对actigraph身体活动原始数据以及AMI 睡眠原始数据的计算服务。'}
      ],
      topImagesNotRouter:[
        {img:require('../assets/images/home/Home_Banner.png'),src:'mailto:service@weiguyun.com?subject=%E4%BA%A7%E5%93%81%E4%BD%BF%E7%94%A8%E7%94%B3%E8%AF%B7',name:'首页',title:'点击申请使用'}
      ],
      topImagesRouter:[
        {img:require('../assets/images/Solution/Case/Case_Banner.png'),to:'/Solution/Case',name:'流行病学调研'},
        {img:require('../assets/images/Solution/HugeData/HugeData_Banner.png'),to:'/Solution/HugeData',name:'大数据计算服务'},
        {img:require('../assets/images/Solution/LCStudies/LCStudies_Banner.png'),to:'/Solution/LCStudies',name:'大型队列人群研究'},
        {img:require('../assets/images/Report/Report_Banner.png'),to:'/Report',name:'中国儿童青少年\n体育健身指数评估报告'}
      ]
    }
  },
  mounted() {
    this.customerAnimal();
    this.changStyle();
  },
  methods: {
    changStyle() {
      var serviceA=document.getElementById('serviceA');
      serviceA.style.color='#000';
      serviceA.style['font-weight'] = 'normal';
      serviceA.onmouseover=function(){
        serviceA.style.color="#74B6EC";
      }
      serviceA.onmouseout=function(){
        serviceA.style.color='#000';
      }
      var solutionA=document.getElementById('solutionA');
      solutionA.style.color='#000';
      solutionA.style['font-weight'] = 'normal';
      solutionA.onmouseover=function(){
        solutionA.style.color="#74B6EC";
      }
      solutionA.onmouseout=function(){
        solutionA.style.color='#000';
      }
    },
    customerAnimal() {
      var customerItems = document.getElementById('customerItems');
      var customerUl = document.getElementById('customerUl');
      var customerLi = document.getElementById('customerUl').getElementsByTagName('li');
      var speed = -2;//初始化速度

      customerUl.innerHTML += customerUl.innerHTML;//图片内容*2
      customerUl.style.width = 272*customerLi.length + 'px';

      function move(){
          if(customerUl.offsetLeft<-(customerUl.offsetWidth/2)){//向左滚动，当靠左的图移出边框时
              customerUl.style.left = 0;
          }

          if(customerUl.offsetLeft > 0){//向右滚动，当靠右的图移出边框时
              customerUl.style.left = -(customerUl.offsetWidth/2)+'px';
          }

          customerUl.style.left = customerUl.offsetLeft + speed + 'px';
      }
      var timer = setInterval(move,30);//全局变量 ，保存返回的定时器

      customerItems.addEventListener('mouseout', function () {
          timer = setInterval(move,30);
      },false);
      customerItems.addEventListener('mousemove', function () {
         clearInterval(timer);//鼠标移入清除定时器
      },false);
    }
  }
}
</script>

<style lang="scss">
#top{
  height: 600px;
}
#top-animal{
  margin: 0 auto;
  height: 600px;
  width: 100%;
}
#top .el-carousel{
  margin: 0 auto;
  max-width:1920px;
}
#top .el-carousel__item div{
  height: 600px;
  width: 100%;
  background-size: auto 100%;
  background-position:center;
  background-repeat: no-repeat;
}
#top .el-carousel__item h3 {
  color: #475669;
  font-size: 14px;
  opacity: 0.75;
  line-height: 150px;
  margin: 0;
}

#top .el-carousel__item:nth-child(2n) {
  background-color: #99a9bf;
}
#top .el-carousel__item:nth-child(2n+1) {
 background-color: #d3dce6;
}
#support{
  padding-bottom: 60px;
}
#CopingStyle{
  background-color: #f9f9f9;
  padding-bottom: 60px;
}
#support a{
  text-decoration: none;
}
#CopingStyle a{
  text-decoration: none;
}
#support .supportTitle{
  margin-top: 60px;
  margin-bottom: 40px;
  color: #606060;
  font-weight: normal;
  font-size: 30px;
}
#CopingStyle .CopingStyleTitle{
  padding-top: 60px;
  margin-bottom: 40px;
  color: #606060;
  font-weight: normal;
  font-size: 30px;
}
#customer .customerTitle{
    padding-top: 60px;
    margin-bottom: 40px;
    color: #606060;
    font-weight: normal;
    font-size: 30px;
}
#home .supportItems,.CopingStyleItems{
  text-align: center;
  min-width: 1080px;
}
#home .supportItems .supportItem2{
  margin-left: 27px;
}
#home .supportItems .supportItem3{
  margin-left: 26px;
}
#home .supportItems .supportItem4{
  margin-left: 27px;
}
#home .CopingStyleItems .CopingStyleItem2{
  margin-left: 27px;
}
#home .CopingStyleItems .CopingStyleItem3{
  margin-left: 26px;
}
#home .CopingStyleItems .CopingStyleItem4{
  margin-left: 27px;
}
#support .supportItems .supportItem1,.supportItem2,.supportItem3,.supportItem4{
  vertical-align: top;
  background-color: #fafafa;
  display: inline-block;
  padding: 10px;
  width: 220px;
  height: 308px;
  border-radius:8px;
  -moz-border-radius:8px; /* 老的 Firefox */
}
#CopingStyle .CopingStyleItems .CopingStyleItem1,.CopingStyleItem2,.CopingStyleItem3,.CopingStyleItem4{
  vertical-align: top;
  background-color: #f0f0f0;
  display: inline-block;
  padding: 10px;
  width: 220px;
  height: 330px;
  border-radius:8px;
  -moz-border-radius:8px; /* 老的 Firefox */
}
#home .itemTitle{
  color: #282828;
  font-weight: normal;
  font-size: 18px;
  margin-top: 20px;
  margin-bottom: 20px;
}
#home .itemContent{
  line-height: 22px;
  color: #909090;
  font-weight: normal;
  font-size: 15px;
  text-align: left;
  text-indent: 2em;
}
#home img{
  width: 220px;
  height: 156px;
  display: block;
}

#customer li{
  float: left;
  width: 248px;
  height: 166px;
  margin-right: 24px;
}
#customer .customerItems{
  width: 1080px;
  height: 166px;
  margin: 0 auto;
  margin-bottom: 60px;
  position:relative;
  overflow: hidden;
}
#customer .customerItems ul{
  position: absolute;
}
</style>



// WEBPACK FOOTER //
// src/pages/Homepage.vue